import isBlankFromPackage from 'is-blank';

export default function isBlank(object) {
  if (object === true || object === false || object === 0) {
    return false;
  }
  if (typeof object === 'string') {
    if (object.length === 0) {
      return true;
    }
    if (object.trim().length > 0) {
      return false;
    }
  }
  return isBlankFromPackage(object);
};